export default __webpack_public_path__ + "static/media/lp_tou3.ec0c700e.png";